import styled from "styled-components";
import { ColorGrayscale, ColorPrimary } from "../utilities/variables";
import { FontFamilyInter } from "../utilities/fonts";
import { Link } from "react-router-dom";
const transitionProperties = 'background, color, border';
function attrsResolution({ $link, $routerLink }) {
    let asType = 'button';
    if ($link) {
        asType = 'a';
    }
    else if ($routerLink) {
        asType = Link;
    }
    return { as: asType };
}
export const ButtonReset = styled.button.attrs(props => attrsResolution(props)) `
    padding: 0;
    margin: 0;

    background: none;
    border: none;
`;
const ButtonBase = styled.button.attrs(props => attrsResolution(props)) `
    cursor: pointer;
    outline: none;

    display: inline-block;
    font-family: 'Inter', sans-serif;
    font-weight: bold;
    font-size: 16px;
    line-height: 16px;
    text-align: center;

    padding: 12px 24px;
    margin: 0;

    color: ${ColorGrayscale.white};
    background: ${ColorGrayscale.black};
    border: none;
    border-radius: 48px;

    transition-property: ${transitionProperties};
    transition-timing-function: ease-in-out;
    transition-duration: 150ms;

    &::after,
    &::before {
        transition-property: ${transitionProperties};
        transition-timing-function: ease-in-out;
        transition-duration: 150ms;
    }

    &:hover,
    &:focus {
        background: ${ColorPrimary.electricBlue};
    }

    &:disabled,
    &.disabled {
        cursor: default;
        color: ${ColorGrayscale.skyDark};
        background: ${ColorGrayscale.skyLight};

        &:hover {
            background: ${ColorGrayscale.skyLight};
        }
    }
`;
export const ButtonMd = styled(ButtonBase) `
    padding: 12px 24px;
`;
export const ButtonLg = styled(ButtonBase) `
    padding: 20px 32px;
`;
export const ButtonBlock = styled(ButtonBase) `
    width: 100%;
    padding: 20px;
`;
export const ButtonLink = styled(ButtonReset) `
    position: relative;
    display: inline-block;
    //styleName: CTAs - Inputs/Textlink - 16pt Bold U;
    ${FontFamilyInter};
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 18px;
    letter-spacing: -0.01em;
    color: ${ColorGrayscale.black};

    transition: all 200ms ease-in-out;

    &::after {
        content: '';
        position: absolute;
        bottom: -2px;
        left: 0;
        right: 0;

        height: 2px;
        background: ${ColorGrayscale.black};

        transition: all 200ms ease-in-out;
    }

    &:hover,
    &:focus {
        outline: none;

        color: ${ColorPrimary.electricBlue};

        &::after {
            background: ${ColorPrimary.electricBlue};
        }
    }
`;
export const ButtonBlockOutline = styled(ButtonBlock) `
    position: relative;
    background: none;
    color: ${ColorGrayscale.black};

    &::after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        border: 2px solid ${ColorGrayscale.black};
        border-radius: 48px;
    }

    &:hover,
    &:focus {
        background: none;
        color: ${ColorPrimary.electricBlue};

        &::after {
            border-color: ${ColorPrimary.electricBlue};
        }
    }
`;
export const ButtonInverted = styled(ButtonBase).attrs({ type: 'button' }) `
    padding: 20px 32px;
    background: ${ColorGrayscale.white};
    color: ${ColorGrayscale.black};

    &:hover {
        background: ${ColorGrayscale.black};
        color: ${ColorGrayscale.white};
    }
`;
